import { render, staticRenderFns } from "./changeStock.vue?vue&type=template&id=5b4c8c79&scoped=true&"
import script from "./changeStock.vue?vue&type=script&lang=js&"
export * from "./changeStock.vue?vue&type=script&lang=js&"
import style0 from "./changeStock.vue?vue&type=style&index=0&id=5b4c8c79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c8c79",
  null
  
)

export default component.exports